import {Component, forwardRef, SimpleChanges, Input, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { CommandGridInputModel } from '../command-gridinput.model';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { CommandGridInputService } from '../command-gridinput.service';
import { TYPE_DEFAULT_VALUE, Model_WorkflowComponent } from 'src/app/app.models';
import { MatDialog } from '@angular/material/dialog';
import { CommandGridInputEmplacementsDialog } from '../command-gridinput-emplacements-dialog/command-gridinput-emplacements-dialog.component';
import { Model_SoudotecDocument } from '../../soudotec.models';

enum Command_View {
    IDLE = 0,
    COMMAND_LOADING = 1,
    COMMAND_LOADED = 2,
    COMMAND_LOADING_ERROR = 3
}

@Component({
    selector: 'abw-command-gridinput-form',
    providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CommandGridInputFormComponent),
        multi: true
    },
    {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CommandGridInputFormComponent),
        multi: true
    }
    ],
    templateUrl: './command-gridinput-form.component.html',
    styleUrls: ['./command-gridinput-form.component.scss']
})
export class CommandGridInputFormComponent extends AbstractWorkflowFormComponent<CommandGridInputModel, Model_SoudotecDocument> {
  @Input() doDomaine: number;
  @Input() doType: number;
  Command_View = Command_View;
  viewMode = Command_View.IDLE;
  doPiece: string = null;
  articles: any[] = [];
  document: any = {};
  errorText: string = null;

  constructor(
    private dialog: MatDialog,
    private _commandGridInputService: CommandGridInputService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();

    let doPiece = '';
    const typeDefaultNumPiece = this.model.additional['TYPE_DEFAULT_NUM_PIECE'];
    if (typeDefaultNumPiece == TYPE_DEFAULT_VALUE.CONSTANT) {
      doPiece = this.model.additional['DEFAULT_NUM_PIECE'];
    } else if (typeDefaultNumPiece == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
      const componentId = this.model.additional['DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_ID'];
      const componentProperty = this.model.additional['DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_PROPERTY'];
      const workflowValues = this._workflowComponentsService.context;
      const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
      let formGroupId = workflowComponent.FORM_ID || '_FORM_';
      const targetComponent: any = workflowValues.formModels[formGroupId].find(component => component.id == componentId);
      if (!!targetComponent) {
          if (!!componentProperty && !!targetComponent.additional && !!targetComponent.additional.NUM_DATASOURCE && !!targetComponent.datas) {
              const selectedData = targetComponent.datas.find(data => data[targetComponent.valueField] == targetComponent.value);
              if (!!selectedData && !!selectedData[componentProperty]) {
              doPiece = selectedData[componentProperty];
              }
          } else {
              doPiece = targetComponent.value;
          }
      }
    }
    this.doPiece = doPiece;

    if (!!this.doPiece) {
      this._doGetSageDocumentAction();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  controlMaxValue(index: any) {
    if (this.doType == 2 && this.document.LIGNES[index].QUANTITE_SAISIE > this.document.LIGNES[index].DL_Qte) {
      this.document.LIGNES[index].QUANTITE_SAISIE = this.document.LIGNES[index].DL_Qte;
    } else if (this.document.LIGNES[index].QUANTITE_SAISIE < 0) {
      this.document.LIGNES[index].QUANTITE_SAISIE = 0;
    }
  }

  onQteInputChanged(inputValue, index) {
    this.document.LIGNES[index].QUANTITE_SAISIE = inputValue;
    this._evaluateSoudotecDocument();
  }

  openEmplacementsDialog(ligne: any) {
    this.dialog.open(CommandGridInputEmplacementsDialog, {
      data: { ligne: ligne },
      width: '95vw',
      panelClass: 'datasource-designer-modal'
    });
  }

  private _evaluateSoudotecDocument() {
    const document: Model_SoudotecDocument = {
      cbMarq: this.document.cbMarq,
      Do_Domaine: this.doDomaine,
      DO_Type: this.doType,
      DO_Piece: this.doPiece,
      DO_Ref: this.document.DO_Ref,
      DO_Tiers: this.document.DO_Tiers,
      DO_Date: this.document.DO_Date,
      DO_TotalHTNet: this.document.DO_TotalHTNet,
      DO_TotalTTC: this.document.DO_TotalTTC,
      LIGNES: this.document.LIGNES.map(ligne => ({ 
        cbMarq: ligne.cbMarq, 
        AR_Ref: ligne.AR_Ref, 
        AR_Design: ligne.DL_Design, 
        AR_CodeBarre: ligne.AR_CodeBarre, 
        DL_Qte: ligne.DL_Qte,
        DL_No: ligne.DL_No,
        ABW_QuantiteSaisie: ligne.QUANTITE_SAISIE
      }))
    };
    this.onValueChanged(document);
  }

  private _doGetSageDocumentAction() {
    return new Promise<void>((resolve, reject) => {
      this.viewMode = Command_View.COMMAND_LOADING;
      this._commandGridInputService.doGetSageDocumentAction(this.doDomaine, this.doType, this.doPiece)
      .subscribe((_document: any) => {
        try {
          this.document = _document;
          this.viewMode = Command_View.COMMAND_LOADED;
          this.onValueChanged(null);
        } catch(e) {
          this.errorText = 'Une erreur est survenue lors de l\'affichage du document. Assurez vous que les paramètres soient correctement synchronisés. (Contactez un administrateur).';
          this.viewMode = Command_View.COMMAND_LOADING_ERROR;
          console.log(e);
        }
        try { this._cdf.detectChanges(); } catch(ex) {}
        resolve();
      }, err => {
        this.errorText = 'Une erreur est survenue lors du chargement de la commande. Veuillez réessayer plus tard.';
        this.viewMode = Command_View.COMMAND_LOADING_ERROR;
        console.log(err);
        reject(err);
      });
    });
  }
}